import { Award, Users, Globe, Shield } from "lucide-react";

const trustStats = [
  { value: "4+", label: "Years of Excellence" },
  { value: "1,500+", label: "Happy Travelers" },
  { value: "50+", label: "Destinations Worldwide" },
  { value: "99%", label: "Customer Satisfaction" },
  { value: "24/7", label: "Customer Support" },
  { value: "100%", label: "Customizable Packages" },
];

const trustPoints = [
  {
    icon: Award,
    title: "3+ Years of Excellence",
    description: "Trusted service from Adajan, Surat – crafting seamless journeys for families across Gujarat since 2023.",
  },
  {
    icon: Users,
    title: "1,500+ Happy Travelers",
    description: "Direct access to your dedicated travel expert – no bots, just real humans in Surat.",
  },
  {
    icon: Globe,
    title: "50+ Destinations Worldwide",
    description: "From local gems to global wonders, we cover domestic and international destinations.",
  },
  {
    icon: Shield,
    title: "24/7 Customer Support",
    description: "We're with you from planning until you're safely home – 100% customizable packages.",
  },
];

export const TrustSection = () => {
  return (
    <section className="section-padding bg-primary text-white" aria-labelledby="trust-heading">
      <div className="container-luxury">
        <div className="text-center space-y-4 mb-14">
          <span className="inline-block px-4 py-1.5 bg-white text-primary text-sm font-semibold rounded-full tracking-wide">
            Why Trust Us
          </span>
          <h2 id="trust-heading" className="section-title text-white">
            Why Choose the Best Travel Agency in Surat?
          </h2>
          <p className="text-white/80 max-w-2xl mx-auto text-base md:text-lg leading-relaxed">
            Experience the difference of traveling with a dedicated team committed to your satisfaction.
          </p>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-16">
          {trustStats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="font-heading font-bold text-3xl md:text-4xl text-white">{stat.value}</p>
              <p className="text-white/70 text-sm mt-2">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustPoints.map((point, index) => (
            <div key={index} className="text-center space-y-4 p-6 rounded-2xl bg-white/5 backdrop-blur-sm">
              <div className="w-16 h-16 rounded-2xl bg-white/15 flex items-center justify-center mx-auto">
                <point.icon className="h-8 w-8 text-gold" aria-hidden="true" />
              </div>
              <h3 className="font-heading font-semibold text-lg">{point.title}</h3>
              <p className="text-white/80 text-sm leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};